jQuery(document).ready(function($) {

    $( ".bloc_bandeau" ).each(function( index ) {

        var parent = $(this)
        var visuel = parent.find(".visuel")

        gsap.from( visuel, {
            y : +100,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 90%",
                end: "bottom 90%",
                scrub: 1,
            }

        })

    })

});